import type { Comparison, Licence, Project } from ".."
import { ShareableTypes, type UserGroupDto } from "../../models"
import { getUserLicences } from "../../services"
import { getGroups, shareWithGroup } from "../../services/UserService"
import type { AppThunkAction, AppThunkDispatch } from "../app.types"
import type { UserActions, UserGroupListAction, UserLicenceAction, UserLicenceListAction } from "./user.types"
import { getAuthenticatedUser } from "../../components/indentity-provider.component"

export const USER_FETCH_GROUPS: string = "USER_FETCH_GROUPS"
export const USER_LOAD_GROUPS: string = "USER_LOAD_GROUPS"

export const USER_FETCH_LICENCES: string = "USER_FETCH_LICENCES"
export const USER_LOAD_LICENCES: string = "USER_LOAD_LICENCES"

export const USER_SELECT_LICENCE: string = "USER_SELECT_LICENCE"

export const USER_SHARE_PROJECT_WITH_GROUP: string = "USER_SHARE_PROJECT_WITH_GROUP"
export const USER_SHARE_COMPARISON_WITH_GROUP: string = "USER_SHARE_COMPARISON_WITH_GROUP"

export function fetchUserGroups(): AppThunkAction<void, UserGroupListAction> {
  return async (dispatch: AppThunkDispatch<UserGroupListAction>) => {
    dispatch({ type: USER_FETCH_GROUPS })

    const groups: UserGroupDto[] = await getGroups()

    dispatch(loadUserGroups(groups))
  }
}

export function shareProjectWithGroup(groups: UserGroupDto[], project: Project): AppThunkAction<void, UserActions> {
  return async (dispatch: AppThunkDispatch<UserActions>) => {
    dispatch({ type: USER_SHARE_PROJECT_WITH_GROUP })

    await shareWithGroup(groups, project, ShareableTypes.PROJECT)
  }
}

export function shareComparisonWithGroup(
  groups: UserGroupDto[],
  comparison: Comparison
): AppThunkAction<void, UserActions> {
  return async (dispatch: AppThunkDispatch<UserActions>) => {
    dispatch({ type: USER_SHARE_COMPARISON_WITH_GROUP })

    await shareWithGroup(groups, comparison, ShareableTypes.COMPARISON)
  }
}

export function loadUserGroups(groups: UserGroupDto[]): UserGroupListAction {
  return {
    type: USER_LOAD_GROUPS,
    payload: groups
  }
}

export function fetchUserLicenceInfo(): AppThunkAction<void, UserLicenceListAction> {
  return async (dispatch: AppThunkDispatch<UserLicenceListAction>) => {
    dispatch({ type: USER_FETCH_LICENCES })

    await segmentIdentify()

    const userLicences: string[] = await getUserLicences()

    dispatch({ type: USER_LOAD_LICENCES, payload: userLicences })
  }
}

export function userSelectLicence(licence: Licence): UserLicenceAction {
  return {
    type: USER_SELECT_LICENCE,
    payload: licence
  }
}

async function segmentIdentify() {
  const user = getAuthenticatedUser()

  window.tracker?.identify({
    id: user.udbId,
    organisationId: user.selectedSchoolId,
    type: user.isTeacher ? "instructor" : "learner"
  })
}
